"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ components, palette, shadows, spacing, typography, mixins }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: mixins.navigation.iconSize,
        height: mixins.navigation.iconSize,
        marginBottom: 4,
        marginRight: spacing(2),
        color: palette.text.secondary,
    },
    personalDetails: {
        border: `1px solid ${palette.divider}`,
        padding: spacing(2),
        backgroundColor: palette.background.default,
        boxShadow: shadows[1],
    },
    contentRow: {
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center',
        marginRight: spacing(2),
    },
});
exports.default = styles;
